import { Notice, Toggle, Why } from '../components/ui.jsx';
import { useT } from '../lib/i18n.jsx';

/**
 * The order matters. `corpus` is the ask that funds everything else and it
 * comes first; `assistant` is the most convenient and the least consequential
 * and it comes last. Nothing here is bundled — four switches, four decisions.
 */
const SCOPES = ['corpus', 'routing', 'cohort', 'assistant'];

export default function Consent({ record, onConsent, busyScope, error, offline }) {
  const t = useT();

  return (
    <section>
      <div className="vh">
        <p className="eyebrow">{t('consent.eyebrow')}</p>
        <h1>
          {t('consent.title.lead')} <em>{t('consent.title.em')}</em>
        </h1>
        <p>{t('consent.lede')}</p>
      </div>

      {offline ? (
        <Notice kind="warn" title={t('consent.offline.title')}>
          {t('consent.offline.body')}
        </Notice>
      ) : null}

      {error ? (
        <Notice kind="bad" title={t('consent.error.title')}>
          {error}
        </Notice>
      ) : null}

      <div className="grid2">
        <div className="card">
          {SCOPES.map((scope) => (
            <Toggle
              key={scope}
              id={`consent-${scope}`}
              checked={Boolean(record.consent[scope])}
              disabled={offline || busyScope === scope}
              onChange={(next) => onConsent(scope, next)}
              title={t(`consent.${scope}.title`)}
              description={t(`consent.${scope}.body`)}
              earn={t(`consent.${scope}.earn`)}
            />
          ))}
        </div>

        <div className="stack">
          <div className="card">
            <p className="eyebrow">{t('consent.earned.title')}</p>
            <span className="mono tabular" style={{ fontSize: '2rem', display: 'block', margin: '8px 0 4px' }}>
              {t('consent.earned.value', { credits: record.credits })}
            </span>
            <p style={{ fontSize: '0.95rem', color: 'var(--muted)', margin: '14px 0 0', lineHeight: 1.6 }}>
              {t('consent.earned.body')}
            </p>
          </div>

          <div className="card">
            <p className="eyebrow">{t('consent.withdraw.title')}</p>
            <p style={{ fontSize: '0.95rem', color: 'var(--muted)', margin: '10px 0 0', lineHeight: 1.7 }}>
              {t('consent.withdraw.body1')}
            </p>
            <p style={{ fontSize: '0.95rem', color: 'var(--muted)', margin: '10px 0 0', lineHeight: 1.7 }}>
              {t('consent.withdraw.body2')}
            </p>
          </div>
        </div>
      </div>

      <Why>
        <strong>Africa has a long and accurate memory of being a research site rather than a research partner.</strong>{' '}
        Compensated, revocable, user-held consent is the only version of this that deserves to work — and it happens to
        also be the only version that is commercially defensible.
      </Why>
    </section>
  );
}
